
// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import LoginView from '../views/LoginView.vue';
import Dashboard from '../views/Dashboard.vue';
import HomeView from '../views/HomeView.vue';
import InspectorManagement from '../views/InspectorManagement.vue';
import UserManagement from '../views/UserManagement.vue';
import PondManagement from '../views/PondManagement.vue';
import WaterQualityData from '../views/WaterQualityData.vue';
import DeviceLogQuery from '../views/DeviceLogQuery.vue';
import DetectionManagement from '../views/DetectionManagement.vue';
import ReagentManagement from '../views/ReagentManagement.vue';
import AccountManagement from '../views/AccountManagement.vue';
import ReagentMonitorAccount from '../views/reagentMonitor/account/index.vue';
import ReagentMonitorAccountDetail from '../views/reagentMonitor/account/detail.vue';
import ReagentMonitorDevice from '../views/reagentMonitor/device/index.vue';
import ReagentMonitorDeviceDetail from '../views/reagentMonitor/device/detail.vue';
import ReagentMonitorWarning from '../views/reagentMonitor/warning/index.vue';
import ReagentMonitorWarningDetail from '../views/reagentMonitor/warning/detail.vue';
import ReagentMonitorConfig from '../views/reagentMonitor/config/index.vue';
import MallProductManagement from '../views/mall/ProductManagement.vue';
import MallOrderManagement from '../views/mall/OrderManagement.vue';
import MallExchangeManagement from '../views/mall/ExchangeManagement.vue';
import MallDeviceBlacklist from '../views/mall/DeviceBlacklist.vue';

const routes = [
  { path: '/login', name: 'Login', component: LoginView },
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    children: [
      { path: '', redirect: '/home' },
      { path: 'home', name: 'Home', component: HomeView },
      { path: 'inspector-management', name: 'InspectorManagement', component: InspectorManagement },
      { path: 'user-management', name: 'UserManagement', component: UserManagement },
      { path: 'pond-management', name: 'PondManagement', component: PondManagement },
      { path: 'water-quality-data', name: 'WaterQualityData', component: WaterQualityData },
      { path: 'workbuddy', name: 'WorkBuddyAuthorization', component: () => import('../views/WorkBuddyAuthorization.vue') },
      { path: 'workbuddy/guide', name: 'WorkBuddyConnectorGuide', component: () => import('../views/WorkBuddyConnectorGuide.vue') },
      { path: 'device-usage-query', name: 'DeviceUsageQuery', component: () => import('../views/DeviceUsageQuery.vue'), meta: { strictSuperAdmin: true } },
      { path: 'device-log-query', name: 'DeviceLogQuery', component: DeviceLogQuery },
      { path: 'detection-management', name: 'DetectionManagement', component: DetectionManagement, meta: { requireSuperAdmin: true } },
      { path: 'reagent-management', name: 'ReagentManagement', component: ReagentManagement, meta: { requireSuperAdmin: true } },
      { path: 'reagent-monitor/account', name: 'ReagentMonitorAccount', component: ReagentMonitorAccount, meta: { requireSuperAdmin: true } },
      { path: 'reagent-monitor/account/detail/:accountId', name: 'ReagentMonitorAccountDetail', component: ReagentMonitorAccountDetail, meta: { requireSuperAdmin: true } },
      { path: 'reagent-monitor/device', name: 'ReagentMonitorDevice', component: ReagentMonitorDevice, meta: { requireSuperAdmin: true } },
      { path: 'reagent-monitor/device/detail/:deviceId', name: 'ReagentMonitorDeviceDetail', component: ReagentMonitorDeviceDetail, meta: { requireSuperAdmin: true } },
      { path: 'reagent-monitor/warning', name: 'ReagentMonitorWarning', component: ReagentMonitorWarning, meta: { requireSuperAdmin: true } },
      { path: 'reagent-monitor/warning/detail/:warningId', name: 'ReagentMonitorWarningDetail', component: ReagentMonitorWarningDetail, meta: { requireSuperAdmin: true } },
      { path: 'reagent-monitor/config', name: 'ReagentMonitorConfig', component: ReagentMonitorConfig, meta: { requireSuperAdmin: true } },
      { path: 'mall/products', name: 'MallProducts', component: MallProductManagement, meta: { requireMallManage: true } },
      { path: 'mall/orders', name: 'MallOrders', component: MallOrderManagement, meta: { requireMallManage: true } },
      { path: 'mall/exchanges', name: 'MallExchanges', component: MallExchangeManagement, meta: { requireMallManage: true } },
      { path: 'mall/device-blacklist', name: 'MallDeviceBlacklist', component: MallDeviceBlacklist, meta: { requireMallManage: true } },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  const permission = Number(localStorage.getItem('permission'));
  const mallManageAuth = Number(localStorage.getItem('mallManageAuth') || '0');
  if (to.name !== 'Login' && !token) {
    next({ name: 'Login' });
  } else if (to.name === 'Login' && token) {
    next({ name: 'Home' });
  } else if (to.meta && to.meta.strictSuperAdmin && localStorage.getItem('permission') !== '0') {
    next({ name: 'Home' });
  } else if (to.meta && to.meta.requireMallManage && mallManageAuth !== 1) {
    next({ name: 'Home' });
  } else if (to.meta && to.meta.requireSuperAdmin) {
    // 检测管理、试剂管理等既有模块保留原有权限规则。
    if (permission !== 0 && mallManageAuth !== 1) {
      next({ name: 'Home' });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
